import React from 'react';
import { Tag } from 'app/components/tag';
import { CodeItem } from 'app/area/codetable/item/types-store';
import { CodeListItem } from 'app/area/codetable/list/types-store';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { isDisabled } from 'app/infrastructure/data/date';

export interface DisabledTagProps {
  codeItem: CodeListItem | CodeItem;
  className?: string;
  translation: CodetableTranslation;
}

export const DisabledTag = ({ codeItem, className, translation }: DisabledTagProps) =>
  !!codeItem && (isDisabled(codeItem.disabled) || (!!codeItem.node && isDisabled(codeItem.node.disabled))
    || (!!codeItem.category && isDisabled(codeItem.category.disabled)))
    ? <Tag className={className}>
      {translation.disabled}
    </Tag>
    : null;
